<a [href]="router.url.includes('#content') ? router.url : router.url + '#content'" tabindex="0" accesskey="s" class="skip-link">Skip to main content</a>

@if (ups.preferences(); as prefs) {
  <div>
    <div
      class="header"
      role="banner"
      [ngStyle]="{
        height: headerHeight + 'px',
        'background-color': prefs.headerColor,
        'background-image': ups.headerBgURL(),
        'border-bottom': prefs.headerBottomBorderStyle,
      }"
    >
      <img
        [ngStyle]="{
          'padding-top': headerHeight / 10 + 'px',
          'padding-bottom': headerHeight / 10 + 'px',
        }"
        [src]="ups.logoURL() || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
        [alt]="(prefs.universityName || '') + ' School Logo'"
      />
      <div
        class="info-bar"
        [ngStyle]="{
          'padding-top': headerHeight / 10 + 'px',
          'padding-bottom': headerHeight / 10 + 'px',
        }"
      >
        @if (!us.isAdmin) {
          @if (ecl.loggedIn()) {
            @if (environment.production) {
              <a mat-raised-button [href]="logoutUrl">Logout</a>
            } @else {
              <button mat-raised-button (click)="logout()">Logout</button>
            }
          }
          @if (!ecl.loggedIn()) {
            <button mat-raised-button color="primary" (click)="signIn()">Sign in with College Board</button>
          }
        }
        @if (us.isAdmin) {
          <div class="preview">
            <button mat-flat-button color="warn">PREVIEW MODE</button>
          </div>
        }
        @if (!environment.production) {
          <span class="header__dev-badge">Dev</span>
        }
      </div>
    </div>
  </div>
}
